import {
    get_headers,
    get_project_id,
    ROLES_URL
} from '@/utils/constants/constants.js';
import axios from 'axios';

export const roles_actions_mixin = {
    data: () => ({
        actions_available: [
            { action: 'Approve', id: 2 }
        ],
        update_action_name: '',
        update_action_description: '',
        show_update_action_modal: false,
        condition_types: ['Submission', 'Selection Verification', 'Approval', 'Time Based'],
        condition_roles: [],
        match_requirements: ['All conditions', 'Any condition'],
        roles: [],
        current_reviewer: null,
        headers: get_headers()
    }),

    mounted() {
        this.get_user_roles();
    },

    methods: {
        get_user_roles() {
            const project_id = get_project_id();
            const params = project_id ? { project_id } : {};

            axios.get(ROLES_URL, { headers: this.headers, params })
                .then(response => {
                    this.roles = response.data.data.map(role => ({
                        id: role.id,
                        role: role.role
                    }));
                    this.condition_roles = this.roles.map(role => role.role);
                })
                .catch(error => {
                    this.show_error('Error fetching roles: ' + error.message);
                });
        },

        update_permissions(reviewer) {
            if (reviewer.role === 'Reviewer') {
                reviewer.permissions = reviewer.permissions || {};
                reviewer.permissions.can_comment = true;
            }
        },

        update_actions() {
            this.show_success("Action updated successfully ");
            this.show_update_action_modal = false;
        },

        capitalize_first_letter(string) {
            if (!string) return '';
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }
};